import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';

export default {
    props: {
        CustomerSourceDisabled: false,
        CustomerLevelDisabled: false,
        isReadOnly: {
            default: null
        },
        value: {
            type: Object,
            default: null
        }
    },
    created() {
        this.setValue();
    },
    data() {
        return {
            result: {
                CustomerSource_Id: null, //必填，客户来源
                CustomerLevel_Id: null, //必填，意向等级
                RegisteredCapital: '', //注册资本
                EmployeeNums: '', //人数规模
                Qualification: '', //公司资质
                IsMajor: 0 //0: 非重点客户, 1: 重点客户
            },
            rules: {
                CustomerSource_Id: [
                    { required: true, message: '请选择客户来源' }
                ],
                CustomerLevel_Id: [
                    { required: true, message: '请选择意向级别' }
                ],
                IsMajor: [
                    { required: true, message: '请选择是否重点客户' }
                ]
            },
            valid: false
        };
    },
    computed: {
        customerLevelList() {
            return this.$store.state.customerLevelList;
        },
        customerSourceList() {
            return this.$store.state.customerSourceList;
        }
    },
    watch: {
        value: {
            deep: true,
            handler: function (val) {
                this.setValue();
            }
        }
    },
    methods: {
        _getFormData() {
            return cloneDeep({
                CustomerSource_Id: '', //必填，客户来源
                CustomerLevel_Id: '', //必填，意向等级
                RegisteredCapital: '', //注册资本
                EmployeeNums: '', //人数规模
                Qualification: '', //公司资质
                IsMajor: 0 //0: 非重点客户, 1: 重点客户
            });
        },
        refGetFormData(){
            return this._getFormData();
        },
        setValue() {
            this.result = cloneDeep($.extend({}, this._getFormData(), this.value));
        },
        validate() {
            this.$refs.form.validate(valid => {
                this.valid = valid;
            });
            if (this.valid) {
                return this.result;
            }
            return false;
        },
        resetFields() {
            this.result = this._getFormData();
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/components/business-form/vm.js